module.exports = __webpack_public_path__ + "static/img/go.277c9a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/go.png
// module id = yT+Q
// module chunks = 1